/** Frontmatter for the "patriots-seahawks-week1-preview" article; the Body lives in patriots-seahawks-week1-preview.jsx. */
const meta = {
  slug: 'patriots-seahawks-week1-preview',
  title: 'Patriots at Seahawks Week 1 Wednesday Preview: Start/Sit, Injuries, and IDP Streamers',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'A Super Bowl LX rematch opens the season Wednesday night at Lumen Field. The defending-champion Seahawks host a retooled Patriots squad in a 3.5-point game. Start/sit calls for both rosters, the Charbonnet injury fallout, and the IDP streamers to grab before kickoff.',
  readMinutes: 9,
  date: '2026-09-08',
};

export default meta;
